// extracted by mini-css-extract-plugin
export default {"zoomModal":"F1-z","image":"G1-z","button":"H1-z","isOverlayShown":"I1-z"};